// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../server/config/ads';
import { buildPostAdModel } from '../../utils/ad_util';

export default function(state = {}, action) {
  const store = action.store;
  const typeMap = {
    PRODUCT_PAGE_LOADING() {
      return {
        isLoading: true,
        productPage: action.productPage
      };
    },
    PRODUCT_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        'most-creative-people',
        'categoryPage'
      );

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.homepage,
        ads: adModelData
      };
    },
    PRODUCT_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.productPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/product_page_reducer.js